import { gql, useMutation } from "@apollo/client";

import { USER_FIELDS, type UserType } from "@/store";

import type { ErrorType } from "../common";

const UPDATE_USER = gql`
  ${USER_FIELDS}

  mutation UpdateUser($input: UserMutationInput!) {
    updateUser(input: $input) {
      errors {
        field
        messages
      }
      user {
        ...UserFields
      }
    }
  }
`;

interface UpdateUserInputType {
  bio?: string;
  coverImageId?: string;
  email?: string;
  facebookUsername?: string;
  firstName?: string;
  image?: string;
  instagramUsername?: string;
  lastName?: string;
  location?: string;
  newsletter?: boolean;
  phoneNumber?: string;
  pronouns?: string;
  tiktokUsername?: string;
  twitterUsername?: string;
  username?: string;
  websiteUrl?: string;
}

interface VariablesType {
  input: UpdateUserInputType;
}

interface DataType {
  updateUser: {
    errors?: ErrorType[];
    user?: UserType;
  };
}

const USER_INPUT_FIELDS: Array<keyof UserType> = [
  "firstName",
  "lastName",
  "email",
  "username",
  "phoneNumber",
  "newsletter",
  // 'image',
  "bio",
  "location",
  "pronouns",
  "instagramUsername",
  "twitterUsername",
  "facebookUsername",
  "tiktokUsername",
  "websiteUrl",
  // 'coverImageId',
];

const USERNAME_PATH_REGEX = /.*(u\/.*)/;

export function imageIdToImageKey(imageId: string) {
  return imageId.replace(USERNAME_PATH_REGEX, "$1");
}

export function userToForm(user: UserType) {
  return USER_INPUT_FIELDS.reduce((accum, field) => {
    if (field in user) {
      // biome-ignore lint/suspicious/noExplicitAny: legacy
      accum[field as keyof UpdateUserInputType] = user[field] as any;
    }
    return accum;
  }, {} as UpdateUserInputType);
}

export default function useUpdateUser() {
  return useMutation<DataType, VariablesType>(UPDATE_USER);
}
